import Transaction from './transaction.table';

export default {
  Transaction,
};
